import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=28a57c8d&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=28a57c8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a57c8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28a57c8d')) {
      api.createRecord('28a57c8d', component.options)
    } else {
      api.reload('28a57c8d', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=28a57c8d&scoped=true&", function () {
      api.rerender('28a57c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-280zw54Rxwdxj/JS/comp/GuestBox.vue"
export default component.exports